/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1LocationCountriesId202,
  PutApiV1LocationCountriesId400,
  PutApiV1LocationCountriesId401,
  PutApiV1LocationCountriesId404,
  PutApiV1LocationCountriesId409,
  PutApiV1LocationCountriesId500,
  PutApiV1LocationCountriesIdMutationRequest,
  PutApiV1LocationCountriesIdMutationResponse,
  PutApiV1LocationCountriesIdPathParams,
} from "../../types/locationCountryController/PutApiV1LocationCountriesId.ts";
import { countryViewModelSchema } from "../countryViewModelSchema.ts";
import { updateCountryRequestViewModelSchema } from "../updateCountryRequestViewModelSchema.ts";

export const putApiV1LocationCountriesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1LocationCountriesIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1LocationCountriesId202Schema = z.lazy(
  () => countryViewModelSchema,
) as unknown as ToZod<PutApiV1LocationCountriesId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1LocationCountriesId400Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1LocationCountriesId401Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1LocationCountriesId404Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesId404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const putApiV1LocationCountriesId409Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesId409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1LocationCountriesId500Schema =
  z.any() as unknown as ToZod<PutApiV1LocationCountriesId500>;

export const putApiV1LocationCountriesIdMutationRequestSchema = z.lazy(
  () => updateCountryRequestViewModelSchema,
) as unknown as ToZod<PutApiV1LocationCountriesIdMutationRequest>;

export const putApiV1LocationCountriesIdMutationResponseSchema = z.lazy(
  () => putApiV1LocationCountriesId202Schema,
) as unknown as ToZod<PutApiV1LocationCountriesIdMutationResponse>;
